const { displayMessage } = require("../services/helper");

const EModulePermissions = {
    ADMIN: { permission_id: 1, name: displayMessage('ADMIN') },
    ACCESS: { permission_id: 2, name: displayMessage('ACCESS') },
}
export default EModulePermissions
